import React, { useState, useEffect, useCallback } from "react";
import { scaleQuantile } from "d3-scale";
import * as d3 from "d3";
import * as topojson from "topojson-client";
import { stateIdToAbbr } from "./data";
import "./RevenueByStateMap.scss";

const RevenueByStateMap = ({revenueData,colors}) => {
  const [statesData, setStatesData] = useState(null);
  const [tooltip, setTooltip] = useState({
    show: false,
    x: 0,
    y: 0,
    content: "",
  });

  useEffect(() => {
    d3.json("https://cdn.jsdelivr.net/npm/us-atlas@3/states-10m.json")
      .then((topology) => {
        const states = topojson.feature(topology, topology.objects.states);
        setStatesData(states);
      })
      .catch((error) => console.error("Error loading the states data:", error));
  }, []);

  const colorScale = statesData
    ? scaleQuantile()
        .domain(Object.values(revenueData))
        .range(colors)
    : null;

  const projection = d3.geoAlbersUsa().scale(1000).translate([400, 300]);
  const pathGenerator = d3.geoPath().projection(projection);

  const handleMouseEnter = useCallback((event, stateAbbr, revenue) => {
    if (revenue) {
      setTooltip({
        show: true,
        x: event.clientX,
        y: event.clientY,
        content: `${stateAbbr}: $${revenue.toLocaleString()}`,
      });
    }
  }, []);

  const handleMouseMove = useCallback((event) => {
    setTooltip((prev) => ({
      ...prev,
      x: event.clientX,
      y: event.clientY,
    }));
  }, []);

  const handleMouseLeave = useCallback(() => {
    setTooltip({ show: false, x: 0, y: 0, content: "" });
  }, []);

  return (
    <div className="revenue-map-container" style={{ position: "relative" }}>
      <svg
        viewBox="0 0 700 610"
        preserveAspectRatio="xMidYMid"
        style={{ width: "100%", height: "auto" }}
      >
        {statesData &&
          statesData.features.map((state) => {
            const stateAbbr = stateIdToAbbr[state.id] || "N/A";
            const revenue = revenueData[stateAbbr] || 0;
            const color = revenue > 0 ? colorScale(revenue) : "#D3D3D3";

            return (
              <path
                key={state.id}
                d={pathGenerator(state)}
                fill={color}
                stroke="#FFFFFF"
                strokeWidth={0.5}
                style={{ cursor: revenue ? "pointer" : "default" }}
                onMouseEnter={(event) =>
                  handleMouseEnter(event, stateAbbr, revenue)
                }
                onMouseMove={handleMouseMove}
                onMouseLeave={handleMouseLeave}
              />
            );
          })}
      </svg>

      {tooltip.show && (
        <div
          style={{
            position: "fixed", // Changed from absolute to fixed
            left: tooltip.x + 10,
            top: tooltip.y + 10,
            backgroundColor: "rgba(0, 0, 0, 0.75)",
            color: "#fff",
            padding: "5px 10px",
            borderRadius: "5px",
            pointerEvents: "none",
            fontSize: "14px",
            whiteSpace: "nowrap",
            transform:
              tooltip.x > window.innerWidth - 150
                ? "translateX(-100%)"
                : "none",
            zIndex: 1000, // Ensure tooltip is above other elements
          }}
        >
          {tooltip.content}
        </div>
      )}
    </div>
  );
};

export default RevenueByStateMap;
